module.exports = __webpack_public_path__ + "img/rato.6baebffb.png";